// extracted by css-extract-rspack-plugin
export default {"cornerHandle":"awaCng","sideHandleH":"FWIKMm","sideHandleV":"AcTCc8","cursorNwse":"f6mb_F","cursorNesw":"hBigqg","moveHandle":"XTSHoa"};